import React from 'react';
import c from 'classnames';
import { useHits } from 'react-instantsearch';
import List from '../List';
const SearchResults = props => {
  const {
    renderItem,
    emptyState,
    className,
    headerElement
  } = props;
  const {
    hits
  } = useHits();
  const classNames = c('Searchkit__SearchResults', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement(List, {
    hits: hits,
    renderItem: renderItem,
    emptyState: emptyState,
    headerElement: headerElement
  }));
};
export default SearchResults;